// The server already computes these (diffit-api app/utils/segments.py). "Could
// teach math" is membership in this set rather than a subject check, because a
// K-5, ELL or SPED teacher teaches math without listing Math as a subject.
export const MATH_CAPABLE_SEGMENTS = [
  'Secondary Math',
  'Lower Elementary',
  'Upper Elementary',
  'ELL',
  'SPED',
];

export const isMathCapable = (diffitUser) =>
  (diffitUser?.user_segments || []).some((segment) =>
    MATH_CAPABLE_SEGMENTS.includes(segment?.name)
  );

// L2 does not imply L1 — they are independent badges_json entries, so a
// certified-educator check that reads only L1 misses L2-only holders.
export const isDonutsAudience = (diffitUser) =>
  !!diffitUser &&
  (!!diffitUser.is_diffit_lead ||
    !!diffitUser.is_certified_educator ||
    !!diffitUser.is_certified_educator_l2 ||
    !!diffitUser.is_ambassador ||
    (!!diffitUser.is_star_teacher && !isMathCapable(diffitUser)));

export const isMathStarTeacher = (diffitUser) =>
  !!diffitUser?.is_star_teacher && isMathCapable(diffitUser);

// An admin of any org they belong to. Someone who is both an admin and a teacher counts as an
// admin, so they get the admin version of an announcement rather than both.
export const isOrgAdmin = (diffitUser) =>
  (diffitUser?.active_orgs || []).some((org) => org?.role === 'Admin');
